import { IncentiveScrappingFilterValue } from './enums';
import { IncentiveScrappingStatusFilter } from './types';

export const FETCH_COMPANY_PREFERENCES_PAGE_SIZE = 200;
export const DEFAULT_TABLE_PAGE_SIZE = 20;
export const TABLE_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
export const STATUS_FILTER_WIDTH = 148;

export const STATUS_OPTIONS: Array<{ value: IncentiveScrappingStatusFilter; label: string }> = [
  { value: null, label: 'Any' },
  { value: IncentiveScrappingFilterValue.On, label: 'On' },
  { value: IncentiveScrappingFilterValue.Off, label: 'Off' },
];

export const BULK_EDIT_TOGGLE_LABELS = {
  on: 'On',
  off: 'Off',
};
